import { ShopStatisticsQuery } from './shop-statistics-query';
export var endpoints = {
    shopStatisticsQuery: new ShopStatisticsQuery(),
};
